// As we're using immer
/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'data';

interface LayoutState {
  distractionFreeMode: boolean;
  documentTabsFreeMode: boolean;
}

export function getFreeModeState(localStorageKey: string) {
  const string = window.localStorage.getItem(localStorageKey);

  return string == null ? false : string === 'true';
}

export const DistractionFreeMode = '__distractionFree';

export const DocumentTabsFreeMode = '__documentsTabsFree';

const INITIAL_STATE: LayoutState = {
  distractionFreeMode: false,
  documentTabsFreeMode: true,
};
const layoutSlice = createSlice({
  name: 'layout',
  initialState: INITIAL_STATE,
  reducers: {
    toggleDistractionFreeMode(
      state,
      { payload }: PayloadAction<boolean>,
    ): LayoutState {
      return {
        ...state,
        distractionFreeMode: payload,
      };
    },
    toggleDocumentTabsFreeMode(
      state,
      { payload }: PayloadAction<boolean>,
    ): LayoutState {
      return {
        ...state,
        documentTabsFreeMode: payload,
      };
    },
  },
});

export const selectDistractionFreeMode = ({ layout }: RootState): boolean =>
  layout.distractionFreeMode;

export const selectDocumentTabsFreeMode = ({ layout }: RootState): boolean =>
  layout.documentTabsFreeMode;

export const { toggleDistractionFreeMode, toggleDocumentTabsFreeMode } =
  layoutSlice.actions;

export const layoutReducer = layoutSlice.reducer;
